import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import FeaturesCallPeopleMagic from 'src/app/organisms/Homepage/FeaturesCallPeopleMagic/FeaturesCallPeopleMagic';

const FeaturesCall = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-7xl', 'spacing-4xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
  >
    <FeaturesCallPeopleMagic />
  </SectionLayout>
);

export default FeaturesCall;
